import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { Redirect } from "react-router-dom";

const RedirectRoute = ({ children }) => {
  const { token } =   useSelector(({ auth }) => auth);

  const isAuthenticated = isEmpty(token) ? false : true;
  
  if (!isAuthenticated) {
    return children;
  }
  return <Redirect to="/dashboard" />;
};

export default RedirectRoute;